document.addEventListener('DOMContentLoaded', function () {
    // Funktion, um den Warenkorb zu prüfen
    function checkCartCollections() {
        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(cart => {
            console.log('Warenkorb-Daten:', cart); // Debugging: Vollständige Warenkorbdaten

            let hasVororder = false;
            let hasNoTag = false;

            // Prüfe jedes Item im Warenkorb
            cart.items.forEach(item => {
                // Da product_tags nicht direkt in /cart.js ist, müssen wir die Tags anders holen
                // Annahme: Tags könnten über eine andere Quelle kommen; vorerst nur Debugging
                console.log('Item:', item.title, 'Variant-ID:', item.variant_id, 'Properties:', item);

                // Workaround: Wir könnten Tags über eine Produkt-API abrufen, aber erstmal prüfen
                // Für jetzt: Annahme, dass Tags in einer versteckten Eigenschaft sind oder fehlen
                const tags = item.tags || item.product_tags || []; // Fallback, falls Tags irgendwo versteckt sind
                console.log('Gefundene Tags:', tags);

                if (tags.includes('vororder')) {
                    hasVororder = true;
                }
                if (tags.length === 0) {
                    hasNoTag = true;
                }
            });

            console.log('Vororder:', hasVororder, 'Kein Tag:', hasNoTag); // Debugging

            // DOM-Elemente
            const checkoutButton = document.querySelector('button[name="checkout"], input[name="checkout"]');
            const existingWarning = document.querySelector('.cart-warning');

            if (hasVororder && hasNoTag) {
                if (!existingWarning && checkoutButton) {
                    let warning = document.createElement('div');
                    warning.className = 'cart-warning';
                    warning.innerHTML = '<p style="color: red; font-weight: bold;">Vororder-Produkte und reguläre Produkte können nicht kombiniert werden!</p>';
                    checkoutButton.disabled = true;
                    checkoutButton.insertAdjacentElement('beforebegin', warning);
                }
            } else {
                if (existingWarning) existingWarning.remove();
                if (checkoutButton) checkoutButton.disabled = false;
            }
        })
        .catch(error => console.error('Fehler beim Abrufen des Warenkorbs:', error));
    }

    // Initiale Prüfung
    checkCartCollections();

    // Event für "In den Warenkorb"-Button
    document.addEventListener('click', function (e) {
        const addToCartButton = e.target.closest('.multivariants_add_to_cart_button');
        if (addToCartButton) {
            console.log('Produkt wird hinzugefügt');
            setTimeout(checkCartCollections, 1000); // Verzögerung, damit der Warenkorb aktualisiert wird
        }
    });

    // Nutze das PUB_SUB_EVENTS.cartUpdate aus deiner cart.js
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        console.log('Cart Update Event:', event); // Debugging
        checkCartCollections();
    });
});

// Hilfsfunktion "subscribe", falls nicht definiert (aus deiner cart.js übernommen)
if (typeof subscribe !== 'function') {
    const events = {};
    window.subscribe = function (eventName, callback) {
        if (!events[eventName]) events[eventName] = [];
        events[eventName].push(callback);
        return () => {
            events[eventName] = events[eventName].filter(cb => cb !== callback);
        };
    };
    window.publish = function (eventName, data) {
        if (events[eventName]) events[eventName].forEach(callback => callback(data));
    };
}